import { render } from "./base-notify-block.vue?vue&type=template&id=f294293c&ts=true"
import script from "./base-notify-block.vue?vue&type=script&lang=ts"
export * from "./base-notify-block.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__